import { handleOpenChat } from "utils/analytics";

export default function Wpp() {

  return (
    <div className="absolute bottom-20 z-10 w-full px-2 overflow-hidden">
      <div className="flex flex-col items-center">
        <p className="text-white text-xl md:text-3xl text-center bg-emerald-700 px-4 py-1 rounded-xl p1">
          Pé na areia em Maragogi
        </p>
        <p className="text-white text-xl md:text-3xl text-center bg-emerald-600 px-4 py-1 rounded-xl mt-2 p2"> 
          Diárias com café da manhã incluso
        </p>
        <p className="text-white text-xl md:text-3xl text-center bg-emerald-600 px-4 py-1 rounded-xl mt-2 p3"> 
          A 150 metros do Caminho de Moisés
        </p>
        <button onClick={handleOpenChat} type="submit" className="mt-2 bg-emerald-500 rounded-lg flex items-center px-4 py-1 a1">
          <img src="/wpp.png" className="h-6 pr-2" alt="RESERVAR" />
          <p className=" text-white text-xl md:text-3xl">
            Fale Conosco
          </p>
        </button>
      </div>
    </div>
  )
}
